import { render } from "./RmaProcess.vue?vue&type=template&id=1f278498&scoped=true&ts=true&lang=pug"
import script from "./RmaProcess.vue?vue&type=script&lang=ts"
export * from "./RmaProcess.vue?vue&type=script&lang=ts"

import "./RmaProcess.vue?vue&type=style&index=0&id=1f278498&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f278498"]])

export default __exports__